import { JsonObject, JsonProperty } from 'json2typescript';
import { AdvancedSearchItemInterface } from '../interfaces/advancedSearchItem.interface';

@JsonObject('AdvancedSearchItemModel')
export class AdvancedSearchItemModel implements AdvancedSearchItemInterface {
  @JsonProperty('AssetClassId', String)
  AssetClassId: string = undefined;

  @JsonProperty('AssetClassName', String)
  AssetClassName: string = undefined;

  @JsonProperty('AssetMainDistributionId', String)
  AssetMainDistributionId: string = undefined;

  @JsonProperty('AssetMainDistributionName', String)
  AssetMainDistributionName: string = undefined;

  @JsonProperty('AssetType', String)
  AssetType: string = undefined;

  @JsonProperty('AssetTypeName', String)
  AssetTypeName: string = undefined;

  @JsonProperty('Behaviour', String)
  Behaviour: string = undefined;

  @JsonProperty('Code', String)
  Code: string = undefined;

  @JsonProperty('Currency', String)
  Currency: string = undefined;

  @JsonProperty('GrupoProductoId', Number)
  GrupoProductoId: number = undefined;

  @JsonProperty('Id', String)
  Id: string = undefined;

  @JsonProperty('IsESG', Boolean)
  IsESG: boolean = undefined;

  @JsonProperty('IsFavourite', Boolean)
  IsFavourite: boolean = undefined;

  @JsonProperty('Isin', String)
  Isin: string = undefined;

  @JsonProperty('IsRecommended', Boolean)
  IsRecommended: boolean = undefined;

  @JsonProperty('LastDate', String)
  LastDate: string = undefined;

  @JsonProperty('LastPrice', Number)
  LastPrice: number = undefined;

  @JsonProperty('Market', String)
  Market: string = undefined;

  @JsonProperty('Id', String)
  Name: string = undefined;

  @JsonProperty('Performance1D', Number)
  Performance1D: number = undefined;

  @JsonProperty('Performance1W', Number)
  Performance1W: number = undefined;

  @JsonProperty('Performance1M', Number)
  Performance1M: number = undefined;

  @JsonProperty('Performance1Y', Number)
  Performance1Y: number = undefined;

  @JsonProperty('Performance3Y', Number)
  Performance3Y: number = undefined;

  @JsonProperty('Performance5Y', Number)
  Performance5Y: number = undefined;

  @JsonProperty('PerformanceYTD', Number)
  PerformanceYTD: number = undefined;

  @JsonProperty('PriceCotation', String)
  PriceCotation: string = undefined;

  @JsonProperty('ProductCode', String)
  ProductCode: string = undefined;

  @JsonProperty('ProductLineId', Number)
  ProductLineId: number = undefined;

  @JsonProperty('ProductLineName', String)
  ProductLineName: string = undefined;

  @JsonProperty('Risk', String)
  Risk: string = undefined;

  @JsonProperty('SRRI', Number)
  SRRI: number = undefined;

  @JsonProperty('Symbol', String)
  Symbol: string = undefined;

  @JsonProperty('TER', Number)
  TER: number = undefined;

  @JsonProperty('Ticker', String)
  Ticker: string = undefined;

  @JsonProperty('UsingForESGCalculation', Boolean)
  UsingForESGCalculation: boolean = undefined;

  @JsonProperty('Volatility', Number)
  Volatility: number = undefined;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
